import Entity from '../entity'

export default class ClaimComplaint extends Entity<number>{
    claim_id: number;
    user_id: number;
    complaint_type_id: number;
    comment: string;
}
